export class WorkspaceLoggingSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsLoggingSettings",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpLoggingSettings",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceLoggingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
